<script>
import Layout from "../../_layouts/main"
import PageHeader from "@/components/page-header"
import Document from '../../../components/api/document'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Document
  },
  data() {
    return {
      title: this.$t('충전'),
      apiUrl: process.env.VUE_APP_API_SERVER_URL + 'deposit',
      response: '',
      body: {
        username: { type: 'text', value: 'user1', desc: this.$t('text.api.username_desc'), required: true, length: '1~21' },
        amount: { type: 'number', value: '0', desc: this.$t('text.api.amount_desc'), required: true }
      }
    };
  },
  mounted() {
    /*
    let host = location.host
    if (host.indexOf('localhost') > -1 || host.indexOf('127.0.0.1') > -1) {
      host = 'http://127.0.0.1:39011/'
    } else {
      host = `https://api.${host}/`
    }

     */
    const host = process.env.VUE_APP_API_SERVER_URL
    this.apiUrl = host + 'deposit'
    // 응답값 설정
    this.response = '{\n' +
        ' "code": 0, \t\t// 응답값(0이 아니면 오류)\n' +
        ' "amount": 1, \t\t// 충전액\n' +
        ' "balance": 100006 \t// 잔액\n' +
        '}'
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title"><span class="badge bg-primary">요청 URL</span> {{ apiUrl }}</div>
            <div class="card-title-desc">{{ $t('text.api_deposit_desc')}}</div>
            <hr/>
            <Document :data="body" :apiUrl="apiUrl" :response="response" :require-vendors="false" :require-ip-address="false" :require-request-key="true" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
